/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef } from 'react';
import { useUIStore } from '../../stores/uiStore';
import { useGetSession } from '../../hooks/useChat';
import { useSubscribeToMessages } from '../../hooks/useSubscribeToMessages';
import MessageItem from './MessageItem';
import MessageInput from './MessageInput';
import TypingText from './TypingText';
import styles from './ChatContainer.module.css';

const ChatContainer: React.FC = () => {
  const { activeSessionId, setActiveSessionId, isLoading } = useUIStore();
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const {
    messages,
    loading,
    error: messagesError
  } = useSubscribeToMessages(activeSessionId || '');

  useGetSession(activeSessionId || '');

  // Scroll to bottom when messages change
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const handleSessionCreated = (sessionId: string) => {
    setActiveSessionId(sessionId);
  };

  const mergedMessages = [];
  for (let i = 0; i < messages.length; i++) {
    const current = messages[i];
    const previous = mergedMessages[mergedMessages.length - 1];

    if (
      previous &&
      current.role === 'assistant' &&
      previous.role === 'assistant'
    ) {
      // Concatenează conținutul și referințele
      // previous.content += '\n' + current.content;
      if (current.references?.length) {
        previous.references = [...(previous.references || []), ...current.references];
      }
    } else {
      mergedMessages.push({ ...current });
    }
  }

  // Show empty state when no session is selected
  if (!activeSessionId) {
    return (
      <div className={styles.container}>
        <div className={styles.emptyState}>
          <img className={styles.logo_img} src="/assets/imgs/logo_zven.png" alt="Logo" />
          <div className={styles.messageInputContainer}>
            <MessageInput onSessionCreated={handleSessionCreated} />
          </div>
        </div>
      </div>
    );
  }

  // Show error state
  if (messagesError) {
    return (
      <div className={styles.container}>
        <div className={styles.emptyState}>
          <h2 className={styles.emptyStateTitle}>Error</h2>
          <p className={styles.emptyStateText}>
            Failed to load messages. Please try again.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.messageList}>
        <div className={styles.messagesWrapper}>
          {mergedMessages?.map((message) => (
              <MessageItem
                key={message.id}
                id={message.id}
                parts={message.parts}
                role={message.role}
                created_at={message.created_at}
                references={message.references}
              />
          ))}
          <div ref={messagesEndRef} />
        </div>
      </div>

      <div className={styles.messageInputContainer}>
        {isLoading && (
          <div className={styles.thinkingMessage}>
            Z
            <TypingText
            text="ven is thinking..."
            showCursor={false}
            speed={50}
            />
          </div>
        )}
        <MessageInput sessionId={activeSessionId} />
      </div>
    </div>
  );
};

export default ChatContainer;